import template from './promote-confirmation.hbs'
import i18n from 'scoreboard/components/i18n'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'

const PromoteConfirmation = ConfirmPrompt.extend({

	/**
	 * Confirmation dialog for promoting an organization to the root level
	 *
	 * @param {Object} options
	 *
	 * @param {String} options.orgLabel the label of the organization that will
	 * be promoted to root
	 *
	 * @param {Object} options.rootOrgLabel the label of the current root organization
	 */
	initialize: function (options) {
		this.options = options || {}
	},

	render: function () {
		this.$el.empty().append(template(this.context()))
		return this
	},

	context: function() {
		return {
			title: i18n.get('admin.organization.promote', this.options.rootOrgLabel),
			promoteInformation: i18n.get('admin.organization.promoteInformation', this.options.orgLabel),
			promoteWarning: i18n.get('admin.organization.promoteWarning')
		}
	}

})

export default PromoteConfirmation
PromoteConfirmation.__filename__ = 'organizations/promote-confirmation.js'
